import { LANG_ENTRY_TYPES } from "../../Data/consts";
import { LANG_V2_NAR, NAR, SUB } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";


/*
{
  _id
  _mastercategory: LanguageData
  _lang_v2: parent id
  type: 'mastercategories'

}
*/
export class Narrative extends LanguageCategory{
  constructor(data){
    super(data)
    // this.changed = false
    this.type = Narrative.getTypeDir()
    this.childTypes = Narrative.getChildTypes()

  }
  toOldLangEntry(){
    let {short, content, _name, _id} = this
    return {
      [`!short`]: short,
      _mask:content,
      _name: _name || _id
    }
  }

  getDisplayText(){
    return this.short
  }

  getFormData(){
    return LanguageCategory.getFormData(Narrative, this)
  }

  static getFormKeys(){
    return ['short', 'content', 'tag']
  }

  static getFormSchema(mapTagOptions = ()=>{}){
    return [
      { name: 'short', required:true, as: 'textarea' },
      { name: 'content', required:true, as:'textarea' },
      { name: 'tag', required:true, as: 'select', children:mapTagOptions(LANG_ENTRY_TYPES)}
    ]
  }

  static getTypeDir(){
    return NAR
  }
  
  static getRelType(){
    return LANG_V2_NAR
  }

  getTypeAddress(){
    return LanguageCategory.getTypeAddress(Narrative)
  }
  static getTypeAddress(){
    return LanguageCategory.getTypeAddress(Narrative)
  }

  static getChildTypes(){
    return []
  }

  static getParentKey(){
    return SUB
  }

  static getParentAddress(){
    return super.getParentAddress(Narrative)
  }

  static constructFromDBData(data){
    return new Narrative(super.constructFromDBData(data, Narrative.getTypeDir()))
    
  }

  static getMongooseSchema(mongoose, Schema ){
    return super.getMongooseSchema(mongoose, Schema, {
      [super.getParentAddress(Narrative)]: {type: mongoose.ObjectId, ref:Narrative.getParentKey(), required:true},
      short: {type:String, required:true},
      tag: {type: String, enum:LANG_ENTRY_TYPES}
    }, Narrative.getTypeDir())
  }


  static getFormColWidths(){
    return {
      parent:2,
      short:3,
      content:6,
      tag:1
    }
  }
}